<template>
    <x-page title="Edit Group">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <group-form id="group-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="group-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { groupIndexUrl, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import { parseMembers } from './helpers'
import GroupForm from './GroupForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GroupForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/groups/${this.$route.params.id}`, {
                params: { 
                    append: [
                        'enter_trigger',
                        'exit_trigger',
                    ],
                    load: [
                        'category',
                        'members',
                        'roles',
                    ],
                }
            })
            .then(response => {
                const data = response.data.data
                this.resource = { 
                    ...data,
                    members: parseMembers(data.members),
                }
                if (data.enter_trigger) {
                    this.resource.enter_trigger.active = true;
                }
                if (data.exit_trigger) {
                    this.resource.exit_trigger.active = true;
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/groups/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} updated!`,
                    })
                    window.location = groupIndexUrl()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>